import { render, staticRenderFns } from "./BarOther.vue?vue&type=template&id=1f702c07&scoped=true&"
import script from "./BarOther.vue?vue&type=script&lang=js&"
export * from "./BarOther.vue?vue&type=script&lang=js&"
import style0 from "./BarOther.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BarOther.vue?vue&type=style&index=1&id=1f702c07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f702c07",
  null
  
)

export default component.exports